import { WorkPackage } from "./Plan"
import { useContext } from 'react'
import { PlanBuilderContext } from './Plan'
import FrmWorkPackage from "./frmWorkPackage";
import DeleteButton from "../ui/delete-button";
import { CloseIcon } from "../ui/Icons/TooltipIcon";

interface WorkstreamBuilderProps {
  workPackage: WorkPackage
}

const WorkPackageBuilder = ({ workPackage }: WorkstreamBuilderProps) => {
  const props = useContext(PlanBuilderContext);

  return (
    <div className="flex flex-col border-2 border-gray-500 rounded-md ml-2 min-w-[450px] h-min">
      <div className="flex flex-row justify-between items-center px-2 bg-planbuilder-workpackage-header text-planbuilder-workpackage-header-foreground">
        <div>
          {workPackage.name}
        </div>
        <div className='flex flex-row my-auto'>
          <DeleteButton
            action={() => props.deleteWorkPackage(workPackage.id)}
            title={"Delete Work Package?"}
            message={"Are you sure you want to delete " + workPackage.name + "?"}
            tooltip={"Delete " + workPackage.name}
          />
          <div className='my-auto' onClick={() => props.setShowEditForm(false)} ><CloseIcon className="text-white rounded-md cursor-pointer hover:bg-red-500" /></div>
        </div>
      </div>
      <div className="flex flex-row justify-between p-4">
        <FrmWorkPackage workPackage={workPackage} />
        
      </div>

    </div>
  )
}

export default WorkPackageBuilder